import React, { ChangeEvent, forwardRef } from "react";
import { Grid2, IconButton, Switch, TextField, Typography } from "@mui/material";
import { AddBudgetItemTemplateRequest, AddPartnerRequest, BudgetItemsTemplateRycApiClient, BudgetItemTemplateDto, PartnerDto, PartnersRycApiClient, UpdateBudgetItemTemplateRequest, UpdatePartnerRequest } from "../../Api/ApiServer";
import { ArrowBack } from "@mui/icons-material";
import { useApi } from "../../Api/useApi";

interface BudgetItemDetailProps {
  budgetItem: BudgetItemTemplateDto;
  onSaved: () => void;
}

export interface BudgetItemDetailRef {
    onSaveBudgetItem: () => void;
}

const BudgetItemDetail = forwardRef<BudgetItemDetailRef, BudgetItemDetailProps>(({ budgetItem, onSaved }, ref) => {
  const [budgetItemState, setBudgetItemState] = React.useState<BudgetItemTemplateDto>(budgetItem);
  const { authorizedApi } = useApi(BudgetItemsTemplateRycApiClient);

  const saveBudgetItem = React.useCallback(async () => {
    // console.log('xxxxxxxxxxxxxxxxxxxx', budgetItemState);
    if (authorizedApi && budgetItemState && budgetItemState.code) {
        // console.log('xxxxxxxxxxxxxxxxxxxx222222222');
        if (!budgetItemState.id) {
            await authorizedApi.addBudgetItemTemplate(new AddBudgetItemTemplateRequest({ budgetItem: budgetItemState})).then(() => {
                // console.log('xxxxxxxxxxxxxxxxxxxx333333333333');
                onSaved();
            });
        } else {
            await authorizedApi.updateBudgetItemTemplate(new UpdateBudgetItemTemplateRequest({ budgetItem: budgetItemState})).then(() => {
                // console.log('xxxxxxxxxxxxxxxxxxxx44444444444444444444');
                onSaved();
            });
        }
    }
  }, [budgetItemState, authorizedApi, onSaved]);

  React.useImperativeHandle(ref, () => ({
    onSaveBudgetItem: saveBudgetItem
  }), [saveBudgetItem]);

  React.useEffect(() => {
    setBudgetItemState(budgetItem);
  }, [budgetItem]);

  return (
    <Grid2 container spacing={2} sx={{ maxWidth: 600, margin: "auto" }}>   
      <Grid2 size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Značka"
          name="code"
          value={budgetItemState.code}
          onChange={(e) => setBudgetItemState(new BudgetItemTemplateDto({ ...budgetItemState, code: e.target.value }))}
          variant="outlined"
        />
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Popis"
          name="description"
          multiline
          maxRows={6}
          value={budgetItemState.description}
          onChange={(e) => setBudgetItemState(new BudgetItemTemplateDto({ ...budgetItemState, description: e.target.value }))}
          variant="outlined"
        />
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <TextField
          fullWidth
          label="Popis objednávky"
          multiline
          maxRows={6}
          name="descriptionContract"
          value={budgetItemState.contractDescription}          
          onChange={(e) => setBudgetItemState(new BudgetItemTemplateDto({ ...budgetItemState, contractDescription: e.target.value }))}
          variant="outlined"
        />
      </Grid2>
    </Grid2>
  );
});

export default BudgetItemDetail;
